<template>
  <div>
    <h1>Souscription active</h1>

    <va-card >
    
      <div class="row align--center">
        <div class="flex xs12 md6">
          <va-input
            :value="term"
            :placeholder="$t('tables.searchByName')"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>

        <div class="flex xs12 md3 offset--md3">
          <va-select
            v-model="perPage"
            :label="$t('tables.perPage')"
            :options="perPageOptions"
            noClear
          />
        </div>
      </div>
      
      
      <va-data-table
        :fields="fields"
        :data="filteredData"
        :per-page="parseInt(perPage)"
      >

      <!-- <template v-slot:create_date="{ create_date }">
        {{ create_date }}
      </template> -->

      <!-- <template slot="actions" slot-scope="props">
        <va-popover :message="`${$t('tables.edit')} ${props.rowData.fullName}`" placement="top">
          <va-button @click="edit(props.rowData)" flat small color="gray" icon="fa fa-pencil" />
        </va-popover>

        <va-popover :message="`${$t('tables.delete')} ${props.rowData.fullName}`" placement="top">
          <va-button @click="remove(props.rowData)" flat small color="gray" icon="fa fa-trash" />
        </va-popover>
      </template> -->

      </va-data-table>
  </va-card>

  </div>

</template>

<script>
import { debounce } from 'lodash'
import service from "../../providers/service";

export default {
  data () {
    return {
      term: null,
      data : [],
      perPage: '6',
      perPageOptions: ['4', '6', '10']
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'buy_hour',
          title: 'Payer l\'heure',
          sortField: 'buy_hour'
        }, 
        {
          name: 'buy_date',
          title: 'Date payer',
          sortField: 'buy_date'
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }
      ]
    },
     filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.data
      }

      return this.data.filter(item => {
        return item.buy_hour.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {
     search: debounce(function (term) {
      this.term = term
    }, 400),

    edit (item) {
      alert('Edit User: ' + JSON.stringify(item))
    },

    remove (item) {

    },

    getListSubscripion(){
      
      service.getSubscription(this.$store.state.accestoken).then( res => {
          
        if(res.status === 200){
          this.data = res.data;
        }
      })

    }

  },
  mounted(){
    this.getListSubscripion();
  }
}
</script>

<style lang="scss">
</style>